import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
var FONT_SIZE_MAP = {
  25: {
    displayText: '12px',
    value: '0.75rem'
  },
  50: {
    displayText: '14px',
    value: '0.875rem'
  },
  100: {
    displayText: '16px',
    value: '1rem'
  },
  200: {
    displayText: '20px',
    value: '1.25rem'
  },
  300: {
    displayText: '24px',
    value: '1.5rem'
  },
  400: {
    displayText: '28px',
    value: '1.75rem'
  },
  500: {
    displayText: '32px',
    value: '2rem'
  },
  600: {
    displayText: '40px',
    value: '2.5rem'
  },
  700: {
    displayText: '48px',
    value: '3rem'
  },
  800: {
    displayText: '56px',
    value: '3.5rem'
  },
  900: {
    displayText: '64px',
    value: '4rem'
  }
};
var ICON_SIZE_MAP = {
  xs: '16px',
  sm: '20px',
  md: '24px',
  lg: '32px',
  xl: '60px'
};
var fontFamilyTokens = {
  'typography-fontfamily-demand': {
    value: 'Lato, "Helvetica Neue", Arial, Helvetica, sans-serif'
  },
  'typography-fontfamily-supply': {
    value: '"Roboto Flex", "Helvetica Neue", Arial, Helvetica, sans-serif'
  }
};
var fontSizeTokens = Object.keys(FONT_SIZE_MAP).reduce(function (tokens, fontSizeKey) {
  return _objectSpread(_objectSpread({}, tokens), {}, _defineProperty({}, "typography-fontsize-".concat(fontSizeKey), {
    displayText: "(".concat(FONT_SIZE_MAP[fontSizeKey].displayText, ")"),
    value: FONT_SIZE_MAP[fontSizeKey].value
  }));
}, {});
var iconSizeTokens = Object.keys(ICON_SIZE_MAP).reduce(function (tokens, iconSizeKey) {
  return _objectSpread(_objectSpread({}, tokens), {}, _defineProperty({}, "typography-iconsize-".concat(iconSizeKey), {
    value: ICON_SIZE_MAP[iconSizeKey]
  }));
}, {});
var lineHeightTokens = {
  'typography-lineheight-default': {
    value: '1.45em'
  },
  'typography-lineheight-dense': {
    value: '1.2em'
  }
};
var fontStyleTokens = {
  'typography-fontstyle-normal': {
    value: 'normal'
  },
  'typography-fontstyle-italic': {
    value: 'italic'
  }
};
var fontWeightTokens = {
  'typography-fontweight-normal': {
    value: '400'
  },
  'typography-fontweight-semibold': {
    value: '600'
  },
  'typography-fontweight-bold': {
    value: '700'
  }
};
var textDecorationTokens = {
  'typography-textdecoration-none': {
    value: 'none'
  },
  'typography-textdecoration-underline': {
    value: 'underline'
  }
};
export var typography = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, fontFamilyTokens), fontSizeTokens), iconSizeTokens), lineHeightTokens), fontStyleTokens), fontWeightTokens), textDecorationTokens);